// extracted by mini-css-extract-plugin
export default {"SelectedOrdination":"SelectOrdination_SelectedOrdination__PUSOq","SelectOrdinationList":"SelectOrdination_SelectOrdinationList__Mf-X-"};